import { MillOverviewPage } from "./MillOverviewPage";

export default MillOverviewPage;
